import React, { useEffect } from "react";
import {
  I2cInput,
  I2cRadio,
  I2cRadioGroup,
  I2cPhoneField,
  I2cListItem,
} from "@webcomponents/i2cwebcomponents/dist/react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";

import "../Prepaid.scss";
import { emailAdressValidator } from "../../../Utils/stringUtls";
export const disputeProcessing = [
  { label: "Managed by i2c inc.", value: 0 },
  { label: "Managed by Sponsor Bank/Issuer/ISO", value: 1 },
  { label: "Other", value: 2 },
];
const ChargeBackAndDisputeProcessing = ({
  setAddFormData,
  addFormData,
  setFormValidStates,
  formDataJson,
  isFetching,
}) => {
  // const isAdd = window.location.pathname.includes("/csd/add") ?? false;
  const generalErrorMessage = "Field is required";
  const validationSchema = Yup.object({
    of_cdp_processor: Yup.number().required(generalErrorMessage).nonNullable(),
    of_cdp_company_name: Yup.string().when("of_cdp_processor", {
      is: (service_type) => service_type === 2,
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    of_cdp_contact_name: Yup.string().when("of_cdp_processor", {
      is: (service_type) => service_type === 2,
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    of_cdp_job_title: Yup.string().when("of_cdp_processor", {
      is: (service_type) => service_type === 2,
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    of_cdp_phone_number: Yup.string().when("of_cdp_processor", {
      is: (service_type) => service_type === 2,
      then: () =>
        Yup.string().required(generalErrorMessage).min(1, generalErrorMessage),
      otherwise: () => Yup.string().optional(),
    }),
    of_cdp_email: Yup.string().when("of_cdp_processor", {
      is: (service_type) => service_type === 2,
      then: () =>
        Yup.string()
          .required(generalErrorMessage)
          .min(1, generalErrorMessage)
          .test("", "", function (item) {
            // this.parent gives the whole parent
            return emailAdressValidator(item);
          }),
      otherwise: () => Yup.string().optional(),
    }),
  });

  // Initialize React Hook Form with Yup resolver
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "all",
    defaultValues: {
      of_cdp_processor: "",
      of_cdp_company_name: "",
      of_cdp_contact_name: "",
      of_cdp_job_title: "",
      of_cdp_phone_number: "",
      of_cdp_country: "",
      of_cdp_email: "",
    },
  });

  // Controlls destructuring from the method
  const {
    control,
    formState: { errors },
  } = methods;
  const fields = [
    "of_cdp_processor",
    "of_cdp_company_name",
    "of_cdp_contact_name",
    "of_cdp_job_title",
    "of_cdp_phone_number",
    "of_cdp_country",
    "of_cdp_email",
  ];
  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) {
      fields.forEach((field) => {
        methods.setValue(field, formDataJson[6]["6_1"][field] ?? "");
      });
      methods.trigger();
    }
  }, [isFetching]);

  // Trigger validation when component mounts
  React.useEffect(() => {
    methods.trigger();
  }, []);

  const handleValueChanges = () => {
    const values = methods.getValues();
    setAddFormData({
      ...addFormData,
      6: {
        ...addFormData["6"],
        "6_1": { ...values },
      },
    });
  };

  // Update form validation state when errors change
  React.useEffect(() => {
    const errorsLength = Object.keys(errors).length;
    if (errorsLength === 0) setFormValidStates("6_1", true);
    else setFormValidStates("6_1", false);
    handleValueChanges();
  }, [Object.keys(errors).length]);

  return (
    <React.Fragment>
      <div className="forms-instance">
        <div i2c-grid="grid gap-sm">
          <div i2c-grid="12">
            <div className="single-field-wrapper">
              <Controller
                name="of_cdp_processor"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    value={methods.watch("of_cdp_processor")}
                    {...field}
                    name="of_cdp_processor"
                    onI2cChange={(e) => {
                      [
                        "of_cdp_company_name",
                        "of_cdp_contact_name",
                        "of_cdp_job_title",
                        "of_cdp_phone_number",
                        "of_cdp_country",
                        "of_cdp_email",
                      ].map((field) => methods.setValue(field, ""));
                      field.onChange(e);
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    <div i2c-grid="grid gap-sm">
                      {disputeProcessing.map((radio, index) => (
                        <I2cListItem
                          key={index}
                          i2c-grid="4@md"
                          variant="receipt"
                          label={radio.label}
                          sublabel=""
                          checked={
                            methods.watch("of_cdp_processor") === radio.value
                          }
                          value={radio.text}
                          type="checkbox"
                        >
                          <I2cRadio
                            slot="prefix"
                            filled
                            value={radio.value}
                            checked={
                              methods.watch("of_cdp_processor") === radio.value
                            }
                          ></I2cRadio>
                        </I2cListItem>
                      ))}
                    </div>
                  </I2cRadioGroup>
                )}
              />
            </div>
          </div>
          {methods.watch("of_cdp_processor") === 2 && (
            <div i2c-grid="12">
              <div className="custom-label-light mb-12">
                If using a 3rd Party Vendor, please provide details:
              </div>
              <div i2c-grid="grid gap-column-sm gap-row-md">
                <div i2c-grid="6@md">
                  <div className="single-field-wrapper">
                    <Controller
                      name="of_cdp_company_name"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          className="single-input-field"
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            handleValueChanges();
                          }}
                          size="large"
                          required
                          label="Company Name"
                          placeholder="Enter Company Name"
                          name={"of_cdp_company_name"}
                        />
                      )}
                    />
                    {/* <ErrorMessage
                      show={
                        errors.of_cdp_company_name &&
                        methods.formState.touchedFields.of_cdp_company_name
                          ? true
                          : false
                      }
                      message={
                        errors.of_cdp_company_name?.message ?? "Invalid input"
                      }
                    /> */}
                  </div>
                </div>
                <div i2c-grid="6@md">
                  <div className="single-field-wrapper">
                    <Controller
                      name="of_cdp_contact_name"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          className="single-input-field"
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            handleValueChanges();
                          }}
                          size="large"
                          required
                          label="Contact Name"
                          placeholder="Enter Contact Name"
                          name={"of_cdp_contact_name"}
                        />
                      )}
                    />
                    {/* <ErrorMessage
                      show={
                        errors.of_cdp_contact_name &&
                        methods.formState.touchedFields.of_cdp_contact_name
                          ? true
                          : false
                      }
                      message={
                        errors.of_cdp_contact_name?.message ?? "Invalid input"
                      }
                    /> */}
                  </div>
                </div>
                <div i2c-grid="6@md">
                  <div className="single-field-wrapper">
                    <Controller
                      name="of_cdp_job_title"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          className="single-input-field"
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            handleValueChanges();
                          }}
                          size="large"
                          label="Job Title"
                          required
                          placeholder="Enter Job Title"
                          name={"of_cdp_job_title"}
                        />
                      )}
                    />
                    {/* <ErrorMessage
                      show={
                        errors.of_cdp_job_title &&
                        methods.formState.touchedFields.of_cdp_job_title
                          ? true
                          : false
                      }
                      message={
                        errors.of_cdp_job_title?.message ?? "Invalid input"
                      }
                    /> */}
                  </div>
                </div>
                <div i2c-grid="6@md">
                  <div className="single-field-wrapper">
                    <I2cPhoneField
                      format="INTERNATIONAL"
                      label="Company Phone "
                      tooltip-help="Custom Text"
                      name="ci_companyName" 
                      size="large"
                      country-box
                      required
                      selectedCountry={methods.watch("of_cdp_country") || "US"}
                      value={methods.watch("of_cdp_phone_number")}
                      errorMessageVisible={false}
                      onI2cChange={(e) => {
                        const country = e.target.country;
                        const isValid = e.target.isValid;
                        const value = e.target.value;
                        methods.setValue("of_cdp_country", country);
                        methods.setValue("of_cdp_phone_number", value);
                        handleValueChanges();
                        if (!isValid) {
                          methods.setError("of_cdp_phone_number", {
                            message: e.target.guide,
                          });
                        } else {
                          methods.clearErrors("of_cdp_phone_number");
                        }
                      }}
                    />
                    {/* <ErrorMessage
												show={
													errors.of_cdp_phone_number &&
													methods.formState.touchedFields.of_cdp_phone_number
														? true
														: false
												}
												message={
													errors.of_cdp_phone_number?.message ?? "Invalid input"
												}
											/> */}
                  </div>
                </div>
                <div i2c-grid="6@md">
                  <div className="single-field-wrapper">
                    <Controller
                      name="of_cdp_email"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          className="single-input-field"
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            handleValueChanges();
                          }}
                          size="large"
                          label="Email"
                          required
                          type="email"
                          placeholder="Enter Email"
                          name={"of_cdp_email"}
                        />
                      )}
                    />
                    {/* <ErrorMessage
                      show={
                        errors.of_cdp_email &&
                        methods.formState.touchedFields.of_cdp_email
                          ? true
                          : false
                      }
                      message={errors.of_cdp_email?.message ?? "Invalid input"}
                    /> */}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default ChargeBackAndDisputeProcessing;
